import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IDiscountProps {
  originalPrice: string;
  discountPercent: string;
}

export const Discount = ({ originalPrice, discountPercent }: IDiscountProps) => {
  return (
    <div className={styles['discount']} data-testid="discount">
      <span className={styles['discount-percent']}>
        <UIText2 color="text-inverted-default" data-testid="discount-percent">
          {discountPercent}
        </UIText2>
      </span>
      <span className={styles['original-price']}>
        <UIText2 color="text-secondary-default" data-testid="discount-original-price">
          {originalPrice}
        </UIText2>
      </span>
    </div>
  );
};
